import { createSlice } from '@reduxjs/toolkit';

const notificationsSlice = createSlice({
  name: 'notifications',
  initialState: {
    alerts: [],           // persistent alerts (maintenance, geofence, route)
    toasts: [],           // ephemeral toast notifications (auto-dismiss)
    wsConnected: false,   // WebSocket connection status
    wsId: null,           // Socket ID
  },
  reducers: {
    setAlerts: (state, action) => {
      state.alerts = action.payload;
    },
    addAlert: (state, action) => {
      state.alerts.unshift(action.payload);
      if (state.alerts.length > 50) state.alerts = state.alerts.slice(0, 50);
    },
    addToast: (state, action) => {
      state.toasts.push({
        id: Date.now() + Math.random(),
        ...action.payload,
        timestamp: new Date().toISOString(),
      });
      if (state.toasts.length > 10) state.toasts = state.toasts.slice(-10);
    },
    removeToast: (state, action) => {
      state.toasts = state.toasts.filter(t => t.id !== action.payload);
    },
    setWSConnected: (state, action) => {
      state.wsConnected = action.payload.connected;
      state.wsId = action.payload.id || null;
    },
  },
});

export const { setAlerts, addAlert, addToast, removeToast, setWSConnected } = notificationsSlice.actions;
export const selectAlerts = (state) => state.notifications.alerts;
export const selectToasts = (state) => state.notifications.toasts;
export const selectWSStatus = (state) => ({ connected: state.notifications.wsConnected, id: state.notifications.wsId });
export default notificationsSlice.reducer;
